// components/About.js
import React from 'react';
import ProfilePhoto from "../Assets/photo.png"

const About = () => {
  return (
    <section id="about" className="p-6 sm:p-8 lg:p-10 shadow-lg bg-gradient-to-r from-blue-400 to-purple-600 mb-20 flex flex-col items-center text-center">
  <h2 className="text-3xl text-gray-800 font-bold mb-4">About Me</h2>
  <p className="mb-4 text-gray-800 max-w-xl">
    Hello! I’m Vilas Lamani, a passionate Software Engineer with over 2.5 years of experience in building web and mobile applications. I graduated from the National Institute of Engineering, Mysore, where I honed my skills in various front-end technologies. My expertise lies in React Native and React JS, along with proficiency in CSS, HTML, and Tailwind CSS for responsive design. I have successfully developed and deployed multiple applications, including two mobile apps and a mobile web application, demonstrating my ability to create intuitive user interfaces and robust functionalities.
    <br /><br />
    I thrive in collaborative environments and enjoy working on projects that challenge my skills and allow me to innovate. I have experience with integrating financial features, such as payment gateways, and using tools like Google Firebase and Postman.
    <br /><br />
    I’m currently seeking new opportunities to further expand my knowledge and expertise in software development, particularly in the areas of mobile app development and cloud services. My goal is to contribute to projects that make a positive impact on users and businesses alike.
    <br /><br />
    Outside of coding, I enjoy exploring new technologies, participating in hackathons, and keeping up with industry trends. I'm always eager to learn and share my knowledge with others.
  </p>
</section>

  );
}

export default About;
